<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['data', 'options'],
  data () {
    return {
      defaultOptions: {
        legend: {
          display: false
        },
        cutoutPercentage: 90,
        tooltips: {
          enabled: false
        }
      },
      defaultData: {
        datasets: [
          {
            label: '',
            borderWidth: 0,
            backgroundColor: ['#ffffff', '#162e4a99'],
            data: [0, 100]
          }
        ]
      }
    }
  },
  mounted () {
    if (this.data) this.defaultData.datasets[0].data = this.data

    this.addPlugin({
      afterDatasetsDraw: function (chartInstance, easing) {
        if (chartInstance.config.type === 'doughnut') {
          var ctx = chartInstance.chart.ctx
          var rate = chartInstance.data.datasets[0].data[0]

          ctx.fillStyle = 'white'
          var fontSize = 40
          var fontStyle = 'normal'
          var fontFamily = 'Helvetica Neue'
          // eslint-disable-next-line
          ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily)

          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          ctx.fillText(`${rate.toString()}%`, 100, 100)
        }
      }
    })
    this.renderChart(this.defaultData, this.options || this.defaultOptions)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/share/DoughnutChart.vue